import React from "react";
import PropTypes from "prop-types";
import useEmblaCarousel from "embla-carousel-react";
import { ClientContext } from "@limitless/common/utils";
import SlideItem from "../slide-item/SlideItem";
import SlideIndicator from "../slide-indicator/SlideIndicator";
import { TEXT_IMAGE_SLIDE } from "../../../utils/HowItWorksCardHelper";
const HowItWorksCarousel = ({
  slides,
  mandatory,
  onNavigate,
  isMobileDevice,
  onClose
}) => {
  const [slideIndex, setSlideIndex] = React.useState(0);
  const [isRtl, setIsRtl] = React.useState(false);
  const [emblaRef, emblaApi] = useEmblaCarousel({
    speed: 15,
    direction: isRtl ? "rtl" : "ltr"
  });

  // Detect RTL layout
  React.useEffect(() => {
    const rtlLayout = document.documentElement.getAttribute("dir") === "rtl";
    setIsRtl(rtlLayout);
  }, []);
  const navigate = () => {
    if (mandatory && slideIndex !== slides.length - 1) {
      setSlideIndex(slideIndex + 1);
    } else {
      onNavigate();
    }
  };

  // Scroll to the updated slide index when it changes
  React.useEffect(() => {
    if (emblaApi) {
      emblaApi.scrollTo(slideIndex);
    }
  }, [emblaApi, slideIndex]);

  // Reinitialize Embla when RTL changes
  React.useEffect(() => {
    if (emblaApi) {
      emblaApi.reInit({
        direction: isRtl ? "rtl" : "ltr"
      });
    }
  }, [emblaApi, isRtl]);
  let slideKey = 0;
  let maxHeight = ClientContext._llmHeight;
  if (slides[0] && slides[0].type === TEXT_IMAGE_SLIDE) {
    maxHeight = "unset";
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "embla",
    ref: emblaRef,
    key: isRtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "embla__container embla__container_hiw",
    style: {
      maxHeight
    }
  }, slides.map(slide => {
    slideKey++;
    return /*#__PURE__*/React.createElement(SlideItem, {
      key: slideKey,
      onButtonClickHandle: navigate,
      slideKey: slideKey,
      shouldAnimate: ClientContext._animation,
      slide: slide,
      isMobileDevice: isMobileDevice,
      onClose: onClose
    });
  }))), /*#__PURE__*/React.createElement(SlideIndicator, {
    slideCount: slides.length,
    onSlideChange: (event, value) => setSlideIndex(value),
    activeSlideIndex: slideIndex
  }));
};
HowItWorksCarousel.propTypes = {
  slides: PropTypes.array.isRequired,
  mandatory: PropTypes.bool,
  onNavigate: PropTypes.func.isRequired,
  isMobileDevice: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
HowItWorksCarousel.defaultProps = {
  mandatory: true
};
export default HowItWorksCarousel;